import { render, staticRenderFns } from "./ProviderCreateUpdate.vue?vue&type=template&id=38b0ad71&"
import script from "./ProviderCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ProviderCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports